import { clsx } from 'clsx'
import styles from './GameweekNavigator.module.css'

type GameweekNavigatorProps = {
  selectedGwNumber: number
  currentGwNumber: number
  totalGws: number
  onPrev: () => void
  onNext: () => void
  isLoading?: boolean
  /**
   * Furthest round the browser may reach. Defaults to `currentGwNumber`, which is right while a
   * competition is under way — there is nothing to see past the round in play.
   *
   * A finished Sobrevivente game passes the game's own last round instead. Its "current" round
   * is the caller's last one, which stops at their elimination: without this the player knocked
   * out in round 24 of a game that ran to 27 could never look at 25, 26 or 27.
   */
  maxGwNumber?: number
}

export function GameweekNavigator({
  selectedGwNumber,
  currentGwNumber,
  onPrev,
  onNext,
  isLoading = false,
  maxGwNumber,
}: GameweekNavigatorProps) {
  const prevDisabled = selectedGwNumber <= 1 || isLoading
  const nextDisabled = selectedGwNumber >= (maxGwNumber ?? currentGwNumber) || isLoading

  return (
    <div className={clsx(styles.container, isLoading && styles.isLoading)}>
      <button
        className={styles.btn}
        onClick={onPrev}
        disabled={prevDisabled}
        aria-label="Rodada anterior"
      >
        ‹
      </button>

      <div className={styles.divider} aria-hidden="true" />

      <span className={styles.label}>Rodada {selectedGwNumber}</span>

      <div className={styles.divider} aria-hidden="true" />

      <button
        className={styles.btn}
        onClick={onNext}
        disabled={nextDisabled}
        aria-label="Próxima rodada"
      >
        ›
      </button>
    </div>
  )
}
